import Icon from 'common-components/Icon'
import * as Styled from './styled'
import { Button, HighlightedText, Text } from 'common-components'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { memo } from 'react'

import ThunderIcon from 'assets/svgr-icons/Thunder.svg'
import InfoCircle from 'assets/svgr-icons/Info_Circle.svg'
import { replaceTranslationVariables } from 'utils/text-transformation'

interface IMobileProps {
  isOpen: boolean
  onClose: () => void
  videoGenerationCost: number
  hasInsufficientCredits: boolean
  handleAnimate: () => void
}

const MobileAnimatePopup = (props: IMobileProps) => {
  const {
    isOpen,
    onClose,
    videoGenerationCost,
    hasInsufficientCredits,
    handleAnimate
  } = props

  const animateAndClose = () => {
    handleAnimate()
    onClose()
  }
  return (
    <Styled.MobilePopupContainer isOpen={isOpen} onClose={onClose}>
      <Styled.MobilePopupContent>
        <Styled.IconWrapper>
          <Icon icon={<InfoCircle />} size="large" color="primaryDark" />
        </Styled.IconWrapper>
        <Styled.TextWrapper>
          <Text type="h1" color="secondaryDark">
            {translate(T.ANIMATE_IMAGE_TITLE)}
          </Text>
          <Text type="h2" color="secondarySemiDark" lineHeight="20px">
            <HighlightedText
              text={replaceTranslationVariables(
                translate(T.ANIMATE_IMAGE_DESCRIPTION),
                [videoGenerationCost.toString()]
              )}
              elementType="span"
              attributes={{
                className: 'highlighted'
              }}
            />
          </Text>
        </Styled.TextWrapper>
      </Styled.MobilePopupContent>
      <Styled.ButtonsWrapper $hasGradientBackground={hasInsufficientCredits}>
        <Button type="secondary" onClick={onClose} className="button">
          {translate(T.CANCEL)}
        </Button>
        <Button
          type="primary"
          onClick={animateAndClose}
          className="animate button"
        >
          {translate(T.ANIMATE)}
          <Styled.IconWithText>
            <Icon icon={<ThunderIcon />} size="small" color="white" />
            <Text type="h4" color="white">
              {videoGenerationCost}
            </Text>
          </Styled.IconWithText>
        </Button>
      </Styled.ButtonsWrapper>
    </Styled.MobilePopupContainer>
  )
}

export default memo(MobileAnimatePopup)
